const { request } = require('./apiClient');

// Thin wrapper around the /oauth endpoints, so components never build URLs by
// hand. Mirrors the shape of the other lib/* API helpers: every function
// returns the unwrapped `data` payload.

function listScopes() {
  return request('/oauth/scopes').then(function(res) {
    return (res && res.data) || [];
  });
}

function listApps() {
  return request('/oauth/apps').then(function(res) {
    return (res && res.data) || [];
  });
}

function createApp(input) {
  return request('/oauth/apps', { method: 'POST', body: input }).then(function(res) {
    return res && res.data;
  });
}

function updateApp(appId, input) {
  return request('/oauth/apps/' + appId, { method: 'PUT', body: input }).then(function(res) {
    return res && res.data;
  });
}

function regenerateSecret(appId) {
  return request('/oauth/apps/' + appId + '/regenerate-secret', { method: 'POST' }).then(function(res) {
    return res && res.data;
  });
}

function deleteApp(appId) {
  return request('/oauth/apps/' + appId, { method: 'DELETE' });
}

// Consent screen: describe what the requesting app wants before approving.
// `query` is the raw OAuth query string from the browser URL.
function getAuthorizeInfo(query) {
  return request('/oauth/authorize-info' + query).then(function(res) {
    return res && res.data;
  });
}

function approveAuthorization(params) {
  return request('/oauth/authorize', { method: 'POST', body: params }).then(function(res) {
    return res && res.data;
  });
}

module.exports = {
  listScopes: listScopes,
  listApps: listApps,
  createApp: createApp,
  updateApp: updateApp,
  regenerateSecret: regenerateSecret,
  deleteApp: deleteApp,
  getAuthorizeInfo: getAuthorizeInfo,
  approveAuthorization: approveAuthorization
};
